<template>
  <div class="w-100">
    <table class="w-100">
      <thead>
        <th class="text-nowrap" style="width: 40px">No</th>
        <th class="text-nowrap">Date Activity</th>
        <th class="text-nowrap">Activity Name</th>
        <th class="text-nowrap">Remarks</th>
        <th class="text-nowrap">Attachment Activity</th>
      </thead>
      <tbody>
        <tr class="bg-white" v-for="(item, index) in data" :key="index">
          <td>{{ index + 1 }}</td>
          <td>{{ formatDate(item?.date_of_activity) }} -
            {{ formatDate(item?.end_of_activity) }}</td>
          <td>{{ item.activity.name ?? '-' }}</td>
          <td>{{ item.notes ?? '-' }}</td>
          <td>
            <div class="mb-1" v-for="(url, idx) in toJosnParse(item.file)" :key="idx" style="width: 120px">
              <!-- {{ url }} -->
              <b-badge class="d-flex align-items-center justify-content-between" @click="handleDownloadFile(url)">
                  <div  class="text-white cursor-pointer">
                    <div class="d-flex align-items-center">
                      <i class="fa fa-download cursor-pointer"></i>
                      <p class="ml-2 mb-0">Attachment</p>
                    </div>
                  </div>
                </b-badge>
              <!-- <AttachmentSR  :file="url"  :isPreview="true"/> -->
              <!-- @delete="() => handleDeleteFile(form, idx)" -->
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="!data?.length" class="p-3 d-flex justify-content-center">
      <img :src="require('@/public/img/not-found-image.png')" alt="not-found-image" width="160" height="140" />
    </div>
  </div>
</template>
<script>
import moment from '@/node_modules/moment/moment'
import AttachmentSR from './AttachmentSR.vue'
import { previewFile } from '@/src/plugins/helpers'

export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      apiUrl: `${process.env.VUE_APP_API_BASE_URL}/sr/`,
    }
  },
  components: {
    AttachmentSR,
  },
  methods: {
    toJosnParse(data){
      return JSON.parse(data)
    },
    handleDownloadFile(item) {
      // saveAs(, 'attachment_activity'+this.getFileExtension(item?.url))
      previewFile(`${this.apiUrl}${item?.url || item?.path}`)
    },
    formatDate(date) {
      return moment(date).format('DD MMM YYYY HH:mm')
    },
    getFileExtension(url){
        const match = url.match(/\.([a-zA-Z0-9]+)(\?|$)/);
        return match ? `.${match[1]}` : null;
    },
  }
}
</script>

<style scoped>
table th {
  padding: 8px;
}

table td {
  padding: 8px;
  border-bottom: 1px solid gray;
}
</style>